var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"fszhezhao"}},[_c('div',{staticClass:"tc o1rem"},[_c('span',[_vm._v(_vm._s(_vm.message))]),_c('img',{attrs:{"src":require("../../assets/jt.png")}})])])}
var staticRenderFns = []

export { render, staticRenderFns }